export const environment = {
  production: true,
  restApiURL: 'glam_rest_api'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts